/** @format */

export const booleanToString = (boolean: boolean): string => {
  return boolean ? "Si" : "No";
};

export const numberToString = (number: number): string => {
  return !!number ? "Si" : "No";
};
